export enum FilesBulkDeliveryRoutes {
  root = 'files-bulk-delivery',
  main = '',
  status = 'status',
}
